import { render, staticRenderFns } from "./ContractPageContent.vue?vue&type=template&id=b9a0c70c&scoped=true&"
import script from "./ContractPageContent.vue?vue&type=script&lang=js&"
export * from "./ContractPageContent.vue?vue&type=script&lang=js&"
import style0 from "./ContractPageContent.vue?vue&type=style&index=0&id=b9a0c70c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a0c70c",
  null
  
)

export default component.exports